import { render } from "./WorkspaceActionBar.vue?vue&type=template&id=5c00a598&scoped=true"
import script from "./WorkspaceActionBar.vue?vue&type=script&lang=js"
export * from "./WorkspaceActionBar.vue?vue&type=script&lang=js"

import "./WorkspaceActionBar.vue?vue&type=style&index=0&id=5c00a598&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c00a598"]])

export default __exports__